import { FormEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NumberParam, StringParam, useQueryParams } from 'use-query-params'

import { ReactComponent as Checkmark } from '../../../../../../assets/icons/checkmark.svg'
import { ConversationsFiltersEnum } from '../../ConversationsFilters'

import styles from './other-category.module.scss'

function OtherCategory() {
    const { t } = useTranslation()

    const [query, setQuery] = useQueryParams({
        [ConversationsFiltersEnum.DATE_FROM]: StringParam,
        [ConversationsFiltersEnum.DATE_TO]: StringParam,
        [ConversationsFiltersEnum.CONVERSATION_LENGTH]: NumberParam,
    })

    const [dateFrom, setDateFrom] = useState<string | undefined>(
        query.date_from || undefined
    )
    const [dateTo, setDateTo] = useState<string | undefined>(
        query.date_to || undefined
    )
    const [length, setLength] = useState<number | undefined>(
        query.length || undefined
    )

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault()
        setQuery({ date_from: dateFrom, date_to: dateTo, length })
    }

    return (
        <form className={styles.otherCategory} onSubmit={handleSubmit}>
            <label className={styles.otherCategory__label}>
                {t('date_from')}:
                <input
                    className={styles.otherCategory__input}
                    type="date"
                    value={dateFrom}
                    onChange={(e) => setDateFrom(e.target.value)}
                />
            </label>
            <label className={styles.otherCategory__label}>
                {t('date_to')}:
                <input
                    className={styles.otherCategory__input}
                    type="date"
                    value={dateTo}
                    onChange={(e) => setDateTo(e.target.value)}
                />
            </label>
            <label className={styles.otherCategory__label}>
                {t('conversation_length')}:
                <input
                    className={styles.otherCategory__input}
                    type="number"
                    value={length}
                    onChange={(e) => setLength(Number(e.target.value))}
                />
            </label>
            <button className={styles.otherCategory__btn} type="submit">
                <Checkmark className={styles.otherCategory__btnIcon} />
            </button>
        </form>
    )
}

export default OtherCategory
